import * as yup from "yup";

export const loginValidationSchema = yup.object().shape({
  email: yup.string().required("is required").email("not valid"),
  password: yup
    .string()
    .required("is required")
    .min(8, "must be at least 8 characters")
    .matches(/(?=.*[a-z])/, "must contain at least one lowercase letter")
    .matches(/(?=.*[A-Z])/, "must contain at least one uppercase letter")
    .matches(/(?=.*\d)/, "must contain at least one number")
    .matches(/(?=.*[@$!%*?&])/, "must contain at least one special character"),
});
